// ===========================================
// One row of the missing-price error list
// ===========================================
// A class with no program level can never match a matrix cell, so Class Pricing is the wrong
// place to send the admin (MNM, 2026-10-04). Its row links to the class's own page, which loads
// ANY class (the Classes list is filtered to the current term, so a deep link into its edit dialog
// silently did nothing for a class in another term); Edit is one click from there.

import { Link, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { extractSchoolSlugFromPath } from '../../utils/routing';
import { formatMissingPrice, type MissingPrice } from './missingPrices';
import { useLinkTargetProps } from './linkTarget';

export default function MissingPriceItem({ missing }: { missing: MissingPrice }) {
  const { pathname } = useLocation();
  const schoolSlug = extractSchoolSlugFromPath(pathname);
  const slugPrefix = schoolSlug ? `/${schoolSlug}` : '';
  const target = useLinkTargetProps();

  if (!missing.noProgramLevel) {
    return (
      <>
        {formatMissingPrice(missing)}
        {missing.hint && (
          <Typography component="span" variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            {missing.hint}
          </Typography>
        )}
      </>
    );
  }

  return (
    <>
      {formatMissingPrice(missing)}{' '}
      <Link component={RouterLink} to={`${slugPrefix}/admin/classes/${missing.lessonId}`} {...target}>
        Open the class to set it
      </Link>
    </>
  );
}
